module.exports = __webpack_public_path__ + "img/stat-card-4.f027fad4.png";